{
  "A": {
    "long": "Activo",
    "short": "activo"
  },
  "BD": {
    "long": "Batería",
    "short": "batería muerta"
  },
  "BES": {
    "long": "La alimentación externa y la batería interna están muy bajas. El dispositivo se apagará pronto.",
    "short": "La batería necesita apagarse"
  },
  "BL": {
    "long": "Batería baja",
    "short": "bajo"
  },
  "BN": {
    "long": "La carga de la batería no es baja",
    "short": "OK"
  },
  "C": {
    "long": "Interruptor cerrado",
    "short": "cerrado"
  },
  "DVS": {
    "long": "El dispositivo está en modo de suspensión",
    "short": "dormido"
  },
  "DVSA": {
    "long": "Dispositivo en suspensión cancelado",
    "short": "modo de suspensión cancelado"
  },
  "DVSQ": {
    "long": "El dispositivo se pondrá en reposo pronto",
    "short": "Modo de suspensión iniciando"
  },
  "DVSW": {
    "long": "El dispositivo se despertó",
    "short": "Acabo de despertarme"
  },
  "FLF": {
    "long": "Fluido",
    "short": "fluido"
  },
  "FLN": {
    "long": "No fluye",
    "short": "No fluye"
  },
  "FLOV": {
    "long": "Fluye Rápido",
    "short": "fluye rápido"
  },
  "GDSBL": {
    "long": "Ubicación deshabilitada",
    "short": "desactivado"
  },
  "GERR": {
    "long": "Error en el chip GPS",
    "short": "error"
  },
  "GLK": {
    "long": "Precisión de ubicación decente",
    "short": "bloqueado"
  },
  "GOFF": {
    "long": "Chip GPS apagado",
    "short": "apagado"
  },
  "GST": {
    "long": "Excelente precisión de ubicación",
    "short": "cerradura fuerte"
  },
  "GULK": {
    "long": "Sin precisión de ubicación",
    "short": "desbloqueado"
  },
  "HHI": {
    "long": "Alto",
    "short": "alto"
  },
  "HNO": {
    "long": "Normal",
    "short": "normal"
  },
  "HLO": {
    "long": "Bajo",
    "short": "bajo"
  },
  "I": {
    "long": "Inactivo",
    "short": "inactivo"
  },
  "MA": {
    "long": "Sin imán",
    "short": "No se detectó ningún imán"
  },
  "MP": {
    "long": "Imán detectado",
    "short": "detectado"
  },
  "NC": {
    "long": "Dispositivo no configurado",
    "short": "No configurado"
  },
  "NONE": {
    "long": "Ninguno",
    "short": "Ninguno"
  },
  "NSIG": {
    "long": "El dispositivo no tiene señal celular",
    "short": "Sin señal"
  },
  "OFF": {
    "long": "Apagado",
    "short": "apagado"
  },
  "ON": {
    "long": "En",
    "short": "en"
  },
  "PHI": {
    "long": "Presión alta",
    "short": "alto"
  },
  "PLO": {
    "long": "Baja presión",
    "short": "bajo"
  },
  "POV": {
    "long": "Por encima del umbral",
    "short": "encima"
  },
  "RE": {
    "long": "Extender a la ubicación de inicio de ejecución",
    "short": "extender"
  },
  "RR": {
    "long": "Retractil",
    "short": "retraer"
  },
  "RS": {
    "long": "Interrumpido",
    "short": "interrumpido"
  },
  "THI": {
    "long": "Alto",
    "short": "alto"
  },
  "TNO": {
    "long": "Normal",
    "short": "normal"
  },
  "TLO": {
    "long": "Bajo",
    "short": "bajo"
  },
  "VFDOF": {
    "long": "VFD apagado",
    "short": "Apagado"
  },
  "VFDOV": {
    "long": "Por encima de la velocidad máxima",
    "short": "Sobre Max"
  },
  "VFDPIDT": {
    "long": "Punto de ajuste de seguimiento",
    "short": "Seguimiento"
  },
  "VFDRP": {
    "long": "Aumento de la frecuencia variable (VFD)",
    "short": "Rampa"
  },
  "VFDST": {
    "long": "VFD activado",
    "short": "En"
  },
  "VFDUN": {
    "long": "Por debajo de la velocidad mínima",
    "short": "Bajo Min"
  },
  "WF": {
    "long": "Moviéndose rápido",
    "short": "rápido"
  },
  "WL": {
    "long": "Moviéndose lentamente",
    "short": "lento"
  },
  "WS": {
    "long": "Interrumpido",
    "short": "interrumpido"
  },
  "WUNK": {
    "long": "Desconocido",
    "short": "Desconocido"
  }
}
